export default "/images/sho-logo.svg?3d271843362278026b763a96ec329812";